import { css } from '@emotion/react'

export const regular = css`
  img {
    max-width: 142px;
    width: 100%;
    height: 42px;
  }
`

export const small = css`
  img {
    width: 84px;
    height: 24px;
  }
`
